// extracted by mini-css-extract-plugin
export default {"frameList":"frameList_frameList__v-7E7"};